<template>
  <div
    class="radio-wrapper">
    <input
      :id="radioId"
      type="radio"
      :value="value"
      :disabled="disabled"
      :name="name"
      @change="radioChanges">
    <label
      :for="radioId"
      :class="selected === value ? 'selected' : ''"
      class="radio-box">
      <span class="font-size:13@m font-size:16">
        {{ label }}
      </span>
    </label>
  </div>
</template>
<script>
export default {
  props: {
    radioId: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    selected: {
      type: String,
      default: '',
    },
  },
  methods: {
    radioChanges(event) {
      this.$emit('input', event);
    },
  },
};
</script>
